/**
 * AI Notes feature constants.
 */
export const AI_NOTES_FEATURE_KEY = 'features/ai-notes';
/**
 * 自动增量总结间隔（毫秒），对齐产品「约 2 分钟」。
 */
export const AI_NOTES_AUTO_SUMMARY_INTERVAL_MS = 120000;
/** @deprecated 保留兼容；会中改走 2 分钟自动总结 */
export const AI_NOTES_DEFAULT_POLL_INTERVAL_MS = AI_NOTES_AUTO_SUMMARY_INTERVAL_MS;
/** Default service URL when config.aiNotes.serviceUrl is empty (same-origin nginx/webpack proxy). */
export const AI_NOTES_DEFAULT_SERVICE_URL = '/meeting-ai';
export const AI_NOTES_SUMMARY_MODE_PARTIAL = 'partial';
export const AI_NOTES_SUMMARY_MODE_FINAL = 'final';
export const AI_NOTES_PATH_SUMMARY = '/v1/meetings';
export const AI_NOTES_PATH_SUMMARIZE_PARTIAL = 'summarize-partial';
export const AI_NOTES_PATH_FINALIZE = 'finalize';
export const AI_NOTES_PATH_SUMMARY_TIMELINE = 'summary-timeline';
export const AI_NOTES_PATH_RECORDINGS = '/v1/recordings';
export const AI_NOTES_PATH_ASSISTANT_CHAT = '/v1/assistant/chat';
/** HTTP 未找到（无纪要 / 最终稿未就绪） */
export const AI_NOTES_HTTP_NOT_FOUND = 404;
/** HTTP 冲突（会议已 finalize） */
export const AI_NOTES_HTTP_CONFLICT = 409;
/** 仅剩本地一人时才允许离会自动 finalize */
export const AI_NOTES_FINALIZE_MAX_PARTICIPANTS = 1;
/** 工具栏 / 更多菜单按钮 key */
export const AI_NOTES_TOOLBAR_BUTTON = 'ainotes';
/** 一分钟毫秒数（倒计时文案） */
export const MS_PER_MINUTE = 60000;
/** 时间线条目 id 前缀（无 updatedAt 时兜底） */
export const AI_NOTES_TIMELINE_ID_PREFIX = 'ai-notes-seg-';
/** 录制会议总结状态 */
export const REC_SUMMARY_STATUS_PENDING = 'pending';
export const REC_SUMMARY_STATUS_PROCESSING = 'processing';
export const REC_SUMMARY_STATUS_READY = 'ready';
export const REC_SUMMARY_STATUS_FAILED = 'failed';
/** 录制总结生成轮询 */
export const REC_SUMMARY_POLL_INTERVAL_MS = 3000;
export const REC_SUMMARY_POLL_MAX_ATTEMPTS = 120;
export const MS_PER_SECOND = 1000;
